import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { useT } from '@/i18n';

export function NotFoundPage(): JSX.Element {
  const t = useT();
  return (
    <div className="text-center py-16">
      <p className="text-sm text-ink-500 mb-2">404</p>
      <h1 className="text-2xl font-semibold text-ink-900 mb-3">{t('notfound.title')}</h1>
      <p className="text-ink-600 mb-6 max-w-md mx-auto">{t('notfound.desc')}</p>
      <Link
        to="/"
        className={cn(
          'inline-flex items-center justify-center h-10 px-4 rounded-md text-sm font-medium',
          'bg-lavender-200 text-lavender-900 hover:bg-lavender-300 transition-colors',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lavender-400 focus-visible:ring-offset-2',
        )}
      >
        {t('notfound.home')}
      </Link>
    </div>
  );
}
